import { exportHack } from '../../utils/exportHack';
import { Table, } from './Table';
import { TableBody, } from './TableBody';
import { TableCell, } from './TableCell';
import { TableHead, } from './TableHead';
import { TableHeader, } from './TableHeader';
import { TableRow, } from './TableRow';
const ExportHackTable = (exportHack({
    component: Table,
    constants: {
        Body: TableBody,
        Cell: TableCell,
        Head: TableHead,
        Header: TableHeader,
        Row: TableRow,
    },
}));
export { ExportHackTable as Table, TableBody, TableCell, TableHead, TableHeader, TableRow, };
